
namespace RioERP.Reports {
    export class ShippingReportColumns {
        static columnsKey = 'Reports.ShippingReport';
    }
}